// extracted by mini-css-extract-plugin
export var avatarContainer = "_gh-0";
export var avatarTypingWave = "_gh-i";
export var gray = "_gh-f";
export var green = "_gh-c";
export var icon = "_gh-9";
export var image = "_gh-1";
export var lg = "_gh-6";
export var md = "_gh-5";
export var presenceDot = "_gh-b";
export var red = "_gh-d";
export var sm = "_gh-4";
export var status = "_gh-a";
export var typingDot = "_gh-h";
export var typingPill = "_gh-g";
export var xl = "_gh-7";
export var xs = "_gh-3";
export var xxl = "_gh-8";
export var xxs = "_gh-2";
export var yellow = "_gh-e";